import { module } from 'modujs';
import gsap from "gsap";
import { onWidthResize } from '../utils/tickers';
import { ENV } from '../config';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        
        this.cards = this.el.querySelectorAll('.brands_item_card');
        this.scale = 0.05;
        this.translateY = ENV.IS_MOBILE ? -10 : -20;
        this.opacity = 0.4;

        window.addEventListener('progressBrands', (e) => {
            const { target, progress } = e.detail;

            if (target.classList.contains('is-inview')) {
                let index = parseInt(target.getAttribute('data-index'));
                for (let i = 0; i < index; i++) {
                    let baseScale = 1 - ((index - 1 - i) * this.scale);
                    let baseTranslate = (index - 1 - i) * this.translateY;
                    let baseOpacity = 1 - ((index - 1 - i) * this.opacity);
                    gsap.set(this.cards[i], {
                        scale: baseScale - (this.scale * progress),
                        y: baseTranslate + (this.translateY * progress),
                        opacity: baseOpacity - (this.opacity * progress),
                    });
                }
            }
        });

        window.addEventListener('brandsState', (e) => {
            const { target, way, from } = e.detail;
            if (way == 'enter') {
                let newIndex = target.getAttribute('data-index');

                let active = this.el.querySelector('.brands_item_logos_logo.-active');
                if (active && active.getAttribute('data-index') != newIndex) {
                    active.classList.remove('-active');
                    active = null;
                }

                this.el.querySelector('.brands_item_logosWrap').setAttribute('data-state', newIndex);                
                this.el.querySelector('.brands_item_logos_logo[data-index="' + newIndex + '"]').classList.add('-active');
            }
        });

        this.sameHeight();
        onWidthResize(() => {
            this.sameHeight()
        });
    }

    sameHeight() {
        let heights = [];

        for (var i = 0; i < this.cards.length; i++) {
            this.cards[i].setAttribute('style', '');
        }
    
        for (var i = 0; i < this.cards.length; i++) {
            heights.push(this.cards[i].offsetHeight);
        }

        let tallest = Math.max(...heights);
    
        for (var i = 0; i < this.cards.length; i++) {
            this.cards[i].style.height = tallest + "px";
        }

        setTimeout(() => {
            this.call('resize', 'Scroll');
        }, 100);
    }
}
